import { useRef, useState } from "react";
import { History } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useHermes } from "./HermesProvider";
import { BrandSiteStudioSessionList } from "./BrandSiteStudioSessionList";

/** 设计工作室：同站多条 brand_site_authoring 场景会话。 */
export function BrandSiteStudioSessionsMenu() {
  const { accountId } = useHermes();
  const [open, setOpen] = useState(false);
  const searchInputRef = useRef<HTMLInputElement>(null);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon-sm"
          className="size-7"
          aria-label="场景会话"
          disabled={!accountId}
        >
          <History className="size-4" />
        </Button>
      </PopoverTrigger>
      <PopoverContent
        align="end"
        className="w-72 p-0"
        onOpenAutoFocus={(event) => {
          event.preventDefault();
          searchInputRef.current?.focus();
        }}
        onCloseAutoFocus={(event) => {
          event.preventDefault();
        }}
      >
        <BrandSiteStudioSessionList
          enabled={open}
          searchInputRef={searchInputRef}
          onSessionChosen={() => setOpen(false)}
        />
      </PopoverContent>
    </Popover>
  );
}
